let unsyncedNodeIds = []
export const addUnsyncedNodeId = (nodeId) => {
    unsyncedNodeIds.push(nodeId)
}

export const getAndResetUnsyncedNodeIds = () => {
    const x = unsyncedNodeIds
    unsyncedNodeIds = []
    return x
}
